import { useCallback, useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Camera, Loader2, Trash2 } from "lucide-react";
import { api, errMsg, fileUrl } from "@/lib/api";
import { compressImage } from "@/lib/format";

export const useEvidence = (woId) => {
  const [items, setItems] = useState([]);
  const reload = useCallback(() => api.get(`/work-orders/${woId}/evidence`).then((r) => setItems(r.data)).catch(() => {}), [woId]);
  useEffect(() => { reload(); }, [reload]);
  return [items, reload];
};

export const SlotPhotos = ({ woId, slot, label, required, items, reload, editable, testid }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const mine = items.filter((e) => e.slot === slot);
  const up = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", await compressImage(f), "foto.jpg");
      fd.append("slot", slot);
      await api.post(`/work-orders/${woId}/evidence`, fd);
      await reload();
      toast.success("Fotografía agregada");
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); e.target.value = ""; }
  };
  const del = async (id) => {
    if (!window.confirm("¿Eliminar esta fotografía?")) return;
    try { await api.delete(`/work-orders/${woId}/evidence/${id}`); await reload(); } catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <div className="space-y-1" data-testid={testid}>
      <div className="flex items-center gap-2 text-xs">
        <span className={mine.length ? "text-emerald-400" : required ? "text-amber-300" : "text-muted-foreground"}>{label}{required ? " *" : ""}</span>
        {editable && <button type="button" onClick={() => ref.current?.click()} disabled={busy} className="ml-auto inline-flex items-center gap-1 rounded-md border border-border px-2 py-1" data-testid={`${testid}-add`}>
          {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Camera className="h-3.5 w-3.5" />}Foto</button>}
        <input ref={ref} type="file" accept="image/*" capture="environment" className="hidden" onChange={up} data-testid={`${testid}-input`} />
      </div>
      {mine.length > 0 && <div className="grid grid-cols-4 gap-2">{mine.map((ev) => (
        <div key={ev.id} className="relative" data-testid={`${testid}-photo`}>
          <img src={fileUrl(`/files/evidence/${ev.id}`)} alt={label} className="aspect-square w-full rounded-md object-cover" />
          {editable && <button type="button" onClick={() => del(ev.id)} className="absolute right-1 top-1 rounded-full bg-background/80 p-1" aria-label="Eliminar foto" data-testid={`${testid}-delete`}><Trash2 className="h-3 w-3 text-destructive" /></button>}
        </div>))}</div>}
    </div>
  );
};

export const OwnSlotPhotos = (props) => {
  const [items, reload] = useEvidence(props.woId);
  return <SlotPhotos {...props} items={items} reload={reload} />;
};
